import _objectSpread from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import { getDomainRRList, updateDomainStatus, deleteDomainRR as _deleteDomainRR, updateDomainRR, batchDeleteDomain, createDomainRR } from "@/api/domain"; //  此处请自行替换地址
import infoList from "@/mixins/infoList";
import { getAllView, viewMapToDomainRegion, getTplMap, mergeRegions, getUUID, regionToView, deepCopy } from '@/utils/viewinfo';
import { checkDomain, isIPv4, isIPv6, compare } from '@/utils/stringFun';
import { enableHealthCheck, disableHealthCheck } from "@/api/biz_hc";
import { updateDomainRemark } from "@/api/domainIndex"; //  此处请自行替换地址
import { store } from '@/store/index';
import HCharts from "@/components/hCharts";
export default {
  name: "DomainListFlat",
  components: {
    HCharts: HCharts
  },
  mixins: [infoList],
  props: {
    qSearchInfo: {
      type: Object,
      require: true
    }
  },
  data: function data() {
    return {
      listApi: getDomainRRList,
      isSticky: false,
      isCollapse: true,
      listAlias: 'domain',
      multipleSelection: [],
      zoneStatus: 0,
      qZone: this.$route.query.zone,
      remarkFormData: {
        remark: ""
      },
      addRemarkDialogFormVisible: false,
      isDisabledSaveBtn: false,
      fullscreenLoading: false,
      queryVisible: false,
      param: {},
      domainRecords: [],
      recordTip: {
        'line': [],
        'value': [],
        'hc': []
      },
      priorityOptions: [{
        label: this.$t('region.priority-primary'),
        value: 0
      }, {
        label: this.$t('region.priority-secondary'),
        value: 1
      }],
      viewOptions: [],
      hcTplMap: new Map(),
      isAddDomain: false,
      domainSeparator: '.',
      tmpDomainRecords: new Map(),
      typePhMap: {
        "A": "98.98.98.98",
        "AAAA": "2001:0db8::8a2e:0370:bab5",
        "CNAME": "www.example.com",
        "PTR": "www.example.com",
        "MX": "10 mailserver.example.com",
        // "TXT": "",
        "NS": "ns1.example.com",
        "SRV": "1 10 80 www.example.com",
        "CAA": "0 issue \"caa.exampleca.com\"",
        "SPF": "v=spf1 ip4:192.168.0.1/16-all",
        "NAPTR": "10 100 \"S\" \"SIP+D2U\" \"\" foo.example.com"
      },
      orderBy: '',
      orderType: 0,
      cloneDialogFormVisible: false,
      cloneFormData: {
        name: ""
      },
      cloneRecords: {},
      searchFilters: {},
      isPtrZone: this.$route.query.zone.endsWith('.in-addr.arpa') || this.$route.query.zone.endsWith('.ip6.arpa')
    };
  },
  computed: {
    zoneSuffixName: function zoneSuffixName() {
      return this.domainSeparator + this.qZone;
    },
    zoneFqName: function zoneFqName() {
      return this.qZone + this.domainSeparator;
    }
  },
  filters: {
    formatDomain: function formatDomain(data) {
      if (data != '.' && data.endsWith('.')) {
        return data.substring(0, data.length - 1);
      }
      return data;
    }
  },
  methods: {
    cascaderRef: function cascaderRef(record) {
      return 'cascader__line__' + record.id;
    },
    stickyOffset: function stickyOffset(pageOffset) {
      this.isSticky = pageOffset > 100;
    },
    formatHc: function formatHc(row) {
      return (row.isHc ? 'ON ' : 'OFF') + ' | ' + (row.priority == 1 ? this.$t('region.priority-secondary') : this.$t('region.priority-primary')) + ' | ' + (row.isHc && row.hc.tplId != 0 ? row.hc.tplName : '-');
    },
    chopSuffix: function chopSuffix(data) {
      if (data != this.domainSeparator && data.endsWith(this.domainSeparator)) {
        return data.substring(0, data.length - 1);
      }
      return data;
    },
    formatStatus: function formatStatus(status) {
      var info = this.$t('domain.status-ok');
      if (status == 1) {
        info = this.$t('domain.status-pause');
      }
      return info;
    },
    formatRecordStatus: function formatRecordStatus(status, record_status) {
      var info = this.$t('domain.status-ok');
      if (status == 1) {
        info = this.$t('domain.status-pause');
      } else if (record_status == 2) {
        info = this.$t('domain.status-error');
      }
      return info;
    },
    domainStatusBtnTip: function domainStatusBtnTip(row) {
      var _tip = '';
      if (row.isPrimaryDomain) {
        _tip = this.$t('domain.domain-opt-status-primary');
      } else if (this.zoneStatus == 2) {
        _tip = this.$t('domain.domain-opt-status-zone');
      } else {
        _tip = row.status == 0 ? this.$t('domain.table-menu-domain-pause') : this.$t('domain.table-menu-domain-enable');
      }
      return _tip;
    },
    domainHcStatusBtnTip: function domainHcStatusBtnTip(row) {
      var _tip = '';
      if (row.status == 1) {
        _tip = this.$t('domain.domain-opt-hcstatus-domain');
      } else if (row.zoneStatus == 2) {
        _tip = this.$t('domain.domain-opt-hcstatus-zone');
      }
      return _tip;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      // 选中主域名时，禁用批量删除按钮
      var ths = this;
      ths.selectedPrimaryDomain = false;
      val.forEach(function (v) {
        if (v.domain == ths.zoneFqName) {
          ths.selectedPrimaryDomain = true;
          return false;
        }
      });
    },
    handleRecorderType: function handleRecorderType(val, record) {
      record.valueTip = this.typePhMap[val] || this.$t('region.dlg-input-value');
      record.value = '';
      if (val != 'A' && val != 'AAAA') {
        record.isHc = false;
        record.hc.tplId = 0;
        record.hc.tplName = '';
      }
    },
    checkAll: function checkAll(checked) {
      console.log(checked);
      this.domainRecords.forEach(function (row) {
        row.checked = checked;
      });
    },
    switchHcStatus: function switchHcStatus(record) {
      if (!record.isHc) {
        record.hc.tplId = 0;
        record.hc.tplName = '';
      }
    },
    filterRecordsBySearch: function filterRecordsBySearch(records) {
      var _this = this;
      return records === null || records === void 0 ? void 0 : records.filter(function (record) {
        if (_this.searchFilters.view && _this.searchFilters.view != '' && _this.searchFilters.view != record.name) {
          return false;
        }
        if (_this.searchFilters.type && _this.searchFilters.type != '' && _this.searchFilters.type != record.type) {
          return false;
        }
        if (_this.searchFilters.value && _this.searchFilters.value != '') {
          if (_this.searchFilters.searchMode == 1 && _this.searchFilters.value != record.value) {
            return false;
          }
          if (_this.searchFilters.searchMode == 0 && record.value.indexOf(_this.searchFilters.value) == -1) {
            return false;
          }
        }
        return true;
      });
    },
    getStatus: function getStatus(data) {
      if (data.hc_status == -1) {
        return this.$t('domain.table-hc-notsetting');
      } else if (data.hc_status == 1) {
        return this.$t('domain.table-hc-disable');
      } else {
        return this.$t('domain.table-hc-enable');
      }
    },
    wrapCommandData: function wrapCommandData(flag, row) {
      return {
        flag: flag,
        row: row
      };
    },
    handleMenuCommand: function handleMenuCommand(_ref) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var flag, row, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              flag = _ref.flag, row = _ref.row;
              if (!row) {
                _context.next = 20;
                break;
              }
              if (!(flag == 'hc')) {
                _context.next = 15;
                break;
              }
              if (!(row.hc_status == 0)) {
                _context.next = 9;
                break;
              }
              _context.next = 6;
              return disableHealthCheck({
                domain: row.domain
              });
            case 6:
              res = _context.sent;
              _context.next = 13;
              break;
            case 9:
              if (!(row.hc_status == 1)) {
                _context.next = 13;
                break;
              }
              _context.next = 12;
              return enableHealthCheck({
                domain: row.domain
              });
            case 12:
              res = _context.sent;
            case 13:
              _context.next = 19;
              break;
            case 15:
              if (!(flag == 'status')) {
                _context.next = 19;
                break;
              }
              _context.next = 18;
              return updateDomainStatus({
                zone: _this2.qZone,
                domain: row.domain,
                status: row.status != 0
              });
            case 18:
              res = _context.sent;
            case 19:
              if (res && res.code == 0) {
                _this2.$message({
                  type: "success",
                  message: _this2.$t('common.msg.opt-success')
                });
                if (flag == 'hc') {
                  row.hc_status = row.hc_status ^ 1;
                } else if (flag == 'status') {
                  row.status = row.status ^ 1;
                  row.hc_status = row.hc_status ^ 1;
                }
              }
            case 20:
              console.log(row);
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    cloneRow: function cloneRow(row) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (_this3.tmpDomainRecords.has(row.domain)) {
                _this3.cloneRecords = deepCopy(_this3.tmpDomainRecords.get(row.domain).records);
              } else {
                _this3.cloneRecords = deepCopy(row.records);
              }
              _this3.cloneDialogFormVisible = true;
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    closeCloneDialog: function closeCloneDialog() {
      this.cloneDialogFormVisible = false;
      this.$refs['cloneFormData'].resetFields();
    },
    saveCloneDialog: function saveCloneDialog(formName) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var isOk, domainName, domain_ip, recordObj, viewObj, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // 校验表单
              isOk = true;
              _this4.$refs[formName].validate(function (valid) {
                if (!valid) {
                  isOk = false;
                  return false;
                }
              });
              if (isOk) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return", false);
            case 4:
              domainName = _this4.cloneFormData.name + '.' + _this4.zoneFqName;
              if (!_this4.isPtrZone) {
                _context3.next = 12;
                break;
              }
              domain_ip = _this4.chopSuffix(domainName).replaceAll('.in-addr.arpa', '').replaceAll('.ip6.arpa');
              domain_ip = domain_ip.split('.').reverse().join('.');
              console.log(domain_ip);
              if (!(!isIPv4(domain_ip) && !isIPv6(domain_ip))) {
                _context3.next = 12;
                break;
              }
              _this4.$message({
                type: 'error',
                showClose: true,
                message: _this4.$t('domain.checkdomain-error-invalid')
              });
              return _context3.abrupt("return");
            case 12:
              recordObj = mergeRegions(_this4.cloneRecords); // 组织成obj
              viewObj = regionToView(recordObj, false);
              viewObj['zone'] = _this4.qZone;
              viewObj['name'] = _this4.cloneFormData.name + '.' + _this4.zoneFqName;
              viewObj['pause'] = false;
              _this4.fullscreenLoading = true;
              _context3.next = 20;
              return createDomainRR(viewObj);
            case 20:
              res = _context3.sent;
              if (res.code == 0) {
                _this4.$message({
                  type: "success",
                  message: _this4.$t('domain.clone-success')
                });
                _this4.closeCloneDialog();
                _this4.domainRecords.unshift({
                  checked: false,
                  domain: viewObj.name,
                  hc_status: -1,
                  remark: '',
                  status: 0,
                  isNew: false,
                  isEdit: false,
                  records: deepCopy(_this4.cloneRecords)
                });
                // this.getTableData();
                _this4.fullscreenLoading = false;
              } else {
                _this4.isDisabledSaveBtn = false;
                _this4.fullscreenLoading = false;
              }
            case 22:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    addRow: function addRow(row) {
      var _this5 = this;
      // 暂存
      this.copyToTmpDomainRecord(row);
      var rid = getUUID();
      row.records.unshift({
        id: rid,
        name: "default",
        label: "默认",
        lines: ["default"],
        type: this.isPtrZone && !row.isPrimaryDomain ? "PTR" : "A",
        value: "",
        valueTip: this.typePhMap[this.isPtrZone ? "PTR" : "A"] || this.$t('region.dlg-input-value'),
        ttl: 600,
        // extend:10,
        weight: 1,
        priority: 0,
        isHc: false,
        isEdit: true,
        hcSettingVisible: false,
        hc: {
          hcStatus: 0,
          tplId: 0,
          tplName: ""
        }
      });
      // 编辑模式
      row.isEdit = true;
      // 设置焦点
      this.$nextTick(function () {
        var recordValues = _this5.$refs['recordValue__' + rid];
        if (recordValues && recordValues.length > 0) {
          recordValues[0].focus();
        }
      });
    },
    addRemark: function addRemark(row) {
      this.remarkFormData.dname = row.domain;
      this.remarkFormData.remark = row.remark;
      this.addRemarkDialogFormVisible = true;
    },
    closeAddRemarkDialog: function closeAddRemarkDialog() {
      this.addRemarkDialogFormVisible = false;
    },
    saveAddRemarkDialog: function saveAddRemarkDialog() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return updateDomainRemark(_this6.remarkFormData);
            case 2:
              res = _context4.sent;
              if (res.code == 0) {
                _this6.$message({
                  type: "success",
                  message: _this6.$t('common.msg.opt-success')
                });
                _this6.closeAddRemarkDialog();
                _this6.domainRecords.some(function (row) {
                  if (row.domain == _this6.remarkFormData.dname) {
                    row.remark = _this6.remarkFormData.remark;
                    return true;
                  }
                  console.log(row.domain);
                });
              }
              _this6.isDisabledSaveBtn = false;
              _this6.fullscreenLoading = false;
              _this6.isAddDomain = false;
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    openQueryDialog: function openQueryDialog(row) {
      this.queryVisible = true;
      this.param = {
        zone: this.qZone,
        domain: row.domain,
        showTop: false
      };
    },
    closeQueryDialog: function closeQueryDialog() {
      this.queryVisible = false;
    },
    showHcTask: function showHcTask(row) {
      this.$router.push({
        name: "hcTask",
        query: {
          domain: row.domain
        }
      });
    },
    isExistEditRecord: function isExistEditRecord(records) {
      return records.some(function (val) {
        return val.isEdit;
      });
    },
    deleteRow: function deleteRow(row, ridx) {
      var _row$records;
      (_row$records = row.records) === null || _row$records === void 0 ? void 0 : _row$records.splice(ridx, 1);
      if (!row.isNew && !this.isExistEditRecord(row.records) && row.records.length == this.getTmpDomainRecordCount(row.domain)) {
        row.isEdit = false;
      }
    },
    deleteDomain: function deleteDomain(row) {
      var _this7 = this;
      this.$confirm(this.$t('common.button.delete') + ' ' + this.chopSuffix(row.domain) + '?', this.$t('common.msg.prompt-title'), {
        confirmButtonText: this.$t('common.button.yes'),
        cancelButtonText: this.$t('common.button.no'),
        type: 'warning'
      }).then(function () {
        _this7.deleteDomainRR(row);
      });
    },
    deleteDomainRR: function deleteDomainRR(row) {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _deleteDomainRR({
                domain: row.domain,
                zone: _this8.qZone
              });
            case 2:
              res = _context5.sent;
              if (res.code == 0) {
                _this8.$message({
                  type: "success",
                  message: _this8.$t('common.msg.delete-success')
                });
                if (_this8.domainRecords.length == 1) {
                  _this8.page--;
                }
                _this8.getDomainRecords();
              }
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    showRecordTip: function showRecordTip(event, record, attr) {
      this.$set(record, attr, event.target.clientWidth < event.target.scrollWidth);
    },
    copyToTmpDomainRecord: function copyToTmpDomainRecord(row) {
      if (!this.tmpDomainRecords.has(row.domain)) {
        this.tmpDomainRecords.set(row.domain, deepCopy(row));
      }
      console.log(this.tmpDomainRecords);
    },
    moveFromTmpDomainRecord: function moveFromTmpDomainRecord(domain) {
      this.tmpDomainRecords.delete(domain);
    },
    getTmpDomainRecord: function getTmpDomainRecord(domain) {
      return deepCopy(this.tmpDomainRecords.get(domain)) || {};
    },
    getTmpDomainRecordCount: function getTmpDomainRecordCount(domain) {
      return this.tmpDomainRecords.has(domain) ? this.tmpDomainRecords.get(domain).records ? this.tmpDomainRecords.get(domain).records.length : 0 : 0;
    },
    recordEdit: function recordEdit(row, record) {
      console.log(row);
      // zone暂停状态，或者记录为非A记录，不能设置健康检查
      // if(col == 'hc' && (this.zoneStatus==2 || record.type != 'A')){
      //   return
      // }
      // 主域名的NS记录不能修改
      if (row.isPrimaryDomain && record.type == 'NS') {
        return;
      }
      // 暂存
      this.copyToTmpDomainRecord(row);
      // 开启编辑模式
      row.isEdit = true;
      record.isEdit = true;
    },
    cancelEdit: function cancelEdit(row, idx) {
      if (row.isNew) {
        this.domainRecords.splice(idx, 1);
        this.isAddDomain = false;
      } else {
        this.domainRecords.splice(idx, 1, this.getTmpDomainRecord(row.domain));
      }
    },
    addDomain: function addDomain() {
      if (this.isAddDomain) {
        return;
      }
      this.domainRecords.unshift({
        checked: false,
        domain: '',
        hc_status: -1,
        remark: '',
        status: 0,
        isNew: true,
        isEdit: true,
        records: [{
          name: "default",
          label: "默认",
          lines: ["default"],
          type: this.isPtrZone ? "PTR" : "A",
          value: "",
          valueTip: this.typePhMap[this.isPtrZone ? "PTR" : "A"] || this.$t('region.dlg-input-value'),
          ttl: 600,
          // extend:10,
          weight: 1,
          priority: 0,
          isHc: false,
          isEdit: true,
          hcSettingVisible: false,
          hc: {
            hcStatus: 0,
            tplId: 0,
            tplName: ""
          }
        }]
      });
      this.isAddDomain = true;
    },
    onDelete: function onDelete() {
      var _this9 = this;
      var domains = [];
      this.domainRecords.forEach(function (row) {
        if (row.checked) {
          domains.push({
            name: row.domain,
            zone: _this9.qZone
          });
        }
      });
      console.log(domains);
      if (domains.length == 0) {
        this.$message({
          type: 'warning',
          message: this.$t('common.msg.delete-choose-warn')
        });
        return;
      }
      this.$confirm(this.$t('common.msg.delete-prompt-info'), this.$t('common.msg.prompt-title'), {
        confirmButtonText: this.$t('common.button.yes'),
        cancelButtonText: this.$t('common.button.no'),
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var res;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return batchDeleteDomain(domains, _this9.qZone);
            case 2:
              res = _context6.sent;
              if (res.code == 0) {
                _this9.$message({
                  type: 'success',
                  message: _this9.$t('common.msg.delete-success')
                });
                if (_this9.tableData.length == domains.length) {
                  _this9.page--;
                }
                _this9.deleteVisible = false;
                _this9.getDomainRecords();
              }
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      })));
    },
    handleHcSetting: function handleHcSetting(record) {
      if (record.hc.tplId) {
        var tplObj = this.hcTplMap.get(record.hc.tplId);
        if (tplObj) {
          record.hc.tplName = tplObj.tplName;
        }
      }
    },
    handleViewChange: function handleViewChange(record) {
      var lineCascaders = this.$refs[this.cascaderRef(record)];
      if (!lineCascaders || lineCascaders.length == 0) {
        return;
      }
      var cascaderObj = lineCascaders[0];
      var nodes = cascaderObj.getCheckedNodes(true);
      if (nodes.length > 0) {
        var _node$pathLabels;
        var node = nodes[0];
        var newLabels = [];
        (_node$pathLabels = node.pathLabels) === null || _node$pathLabels === void 0 ? void 0 : _node$pathLabels.forEach(function (label) {
          newLabels.push(label);
        });
        record.name = node.path[node.path.length - 1];
        record.label = newLabels.join('/');
      }

      // 切换记录类型, 非默认线路只支持A、AAAA、CNAME
      if (record.name != 'default' && record.type != 'A' && record.type != 'AAAA' && record.type != 'CNAME') {
        // this.$message({
        //   type: 'error',
        //   showClose: true,
        //   message: '非默认线路，不支持' + record.type + '类型的记录'
        // });
        record.type = 'A';
      }
    },
    validateForm: function validateForm(recordObj, isPrimaryDomain) {
      var _recordObj$region,
        _this10 = this;
      var err = [];
      if (!recordObj.default.names || recordObj.default.names.length == 0) {
        err.push(this.$t('domain.validate-no-default-region'));
        return err;
      }
      err = this.validateRegion(recordObj.default, isPrimaryDomain);
      (_recordObj$region = recordObj.region) === null || _recordObj$region === void 0 ? void 0 : _recordObj$region.forEach(function (region) {
        var smartErr = _this10.validateRegion(region, isPrimaryDomain);
        err = [].concat(_toConsumableArray(err), _toConsumableArray(smartErr));
      });
      return err;
    },
    validateRegion: function validateRegion(region, isPrimaryDomain) {
      var _this11 = this;
      var err = [];
      if (!region.names || region.names.length == 0) {
        err.push(this.$t('domain.validate-no-region'));
      }
      var _typeMap = new Map();
      var valueMap = new Map();
      var masterRecCount = 0;
      var hc_masterRecCount = 0;
      var slaverRecCount = 0;
      var tplId = 0;
      region.targets.forEach(function (target) {
        target.priority = target.priority || 0;
        var priorityDes = '';
        if (region.hc.tplName != '') {
          priorityDes = target.priority == 1 ? '备' : '主';
        }
        if (!_typeMap.has(target.priority)) {
          _typeMap.set(target.priority, target.type);
        }
        if (target.value == '') {
          err.push(_this11.$t('domain.validate-no-value'));
          return true;
        }
        if (valueMap.has(target.value) && valueMap.get(target.value) == target.type) {
          err.push(_this11.$t('domain.validate-exists-value'));
          return true;
        }
        valueMap.set(target.value, target.type);

        // 主记录
        if (target.priority == 0) {
          masterRecCount++;
          if ((target.type == 'A' || target.type == 'AAAA') && target.isHc) {
            hc_masterRecCount++;
          }
        }
        if (target.priority == 1) {
          slaverRecCount++;
        }
        if (target.isHc) {
          if (target.hc.tplId == 0) {
            err.push(_this11.$t('domain.validate-no-select-hc-tpl'));
            return true;
          }
          if (tplId != 0 && target.hc.tplId != tplId) {
            err.push(_this11.$t('domain.validate-diff-hc-tpl'));
            return true;
          }
          tplId = target.hc.tplId;
        }
        if (target.ttl < 60 || target.ttl > 604800) {
          err.push(_this11.$t('domain.validate-ttl-scope'));
        }
        if (target.type == '') {
          err.push(_this11.$t('domain.validate-no-type'));
        } else if (target.type == 'CNAME') {
          // 判断域名是否正确
          if (!checkDomain(target.value) || isIPv4(target.value)) {
            err.push(target.type + _this11.$t('domain.validate-invalid-value'));
          }

          // 判断类型并存
          if (_typeMap.get(target.priority) != target.type) {
            err.push(_this11.$t('domain.validate-coexist-region') + priorityDes + '，' + target.type + _this11.$t('domain.validate-coexist-type'));
          }
        } else if (target.type == 'NS') {
          // 判断域名是否正确
          if (!checkDomain(target.value) || isIPv4(target.value)) {
            err.push(target.type + _this11.$t('domain.validate-invalid-value'));
          }

          // 判断类型并存
          if (!isPrimaryDomain && _typeMap.get(target.priority) != target.type) {
            err.push(_this11.$t('domain.validate-coexist-region') + priorityDes + '，' + target.type + _this11.$t('domain.validate-coexist-type'));
          }
        } else {
          if (target.type == 'A') {
            // 判断ip是否正确
            if (!isIPv4(target.value)) {
              err.push(target.type + _this11.$t('domain.validate-invalid-value'));
            }
            if (target.weight < 0 || target.weight > 10) {
              err.push(_this11.$t('domain.validate-weight-scope'));
            }
          } else if (target.type == 'AAAA') {
            // 判断ip是否正确
            if (!isIPv6(target.value)) {
              err.push(target.type + _this11.$t('domain.validate-invalid-value'));
            }
          } else if (target.type == 'PTR') {
            // 判断ip是否正确
            if (!checkDomain(target.value) || isIPv4(target.value)) {
              err.push(target.type + _this11.$t('domain.validate-invalid-value'));
            }
          }
          // 判断类型并存
          if (_typeMap.get(target.priority) == 'CNAME') {
            err.push(_this11.$t('domain.validate-coexist-region') + priorityDes + '，' + target.type + _this11.$t('domain.validate-coexist-cname'));
          }
          if (!isPrimaryDomain && _typeMap.get(target.priority) == 'NS') {
            err.push(_this11.$t('domain.validate-coexist-region') + priorityDes + '，' + target.type + _this11.$t('domain.validate-coexist-ns'));
          }
        }
      });
      if (slaverRecCount > 0 && (masterRecCount != hc_masterRecCount || masterRecCount == 0)) {
        err.push(this.$t('domain.validate-need-set-master'));
      }
      return err;
    },
    saveRecord: function saveRecord(row) {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var domainName, recordObj, err, msgArr, viewObj, res, _row$records2, isExistHc;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(row.domain == '')) {
                _context7.next = 3;
                break;
              }
              _this12.$message({
                type: 'error',
                showClose: true,
                message: _this12.$t('domain.checkdomain-error-empty')
              });
              return _context7.abrupt("return");
            case 3:
              console.log(row);
              domainName = row.isNew ? row.domain + '.' + _this12.zoneFqName : row.domain; // if(this.isPtrZone){
              //   const domain_ip = this.getReverseIP(domainName)
              //   console.log(domain_ip)
              //   if(!row.isPrimaryDomain && !isIPv4(domain_ip) && !isIPv6(domain_ip)){
              //     this.$message({
              //       type: 'error',
              //       showClose: true,
              //       message: this.$t('domain.checkdomain-error-invalid')
              //     });
              //     return
              //   }
              // }
              // 校验
              recordObj = mergeRegions(row.records);
              err = _this12.validateForm(recordObj, row.isPrimaryDomain);
              if (!(err.length > 0)) {
                _context7.next = 12;
                break;
              }
              msgArr = [];
              err.forEach(function (val) {
                msgArr.push('<li style="margin: 5px 0;">' + val + '</li>');
              });
              _this12.$message({
                type: 'error',
                showClose: true,
                dangerouslyUseHTMLString: true,
                message: '<ul>' + msgArr.join("") + '</ul>'
              });
              return _context7.abrupt("return", false);
            case 12:
              _this12.isDisabledSaveBtn = true;

              // 组织成obj
              viewObj = regionToView(recordObj, row.isPrimaryDomain);
              viewObj['zone'] = _this12.qZone;
              viewObj['name'] = domainName;
              viewObj['pause'] = row.status;
              _this12.fullscreenLoading = true;
              res = {};
              if (!row.isNew) {
                _context7.next = 25;
                break;
              }
              _context7.next = 22;
              return createDomainRR(viewObj);
            case 22:
              res = _context7.sent;
              _context7.next = 28;
              break;
            case 25:
              _context7.next = 27;
              return updateDomainRR(viewObj);
            case 27:
              res = _context7.sent;
            case 28:
              if (res.code == 0) {
                _this12.$message({
                  type: "success",
                  message: _this12.$t('common.msg.save-success')
                });
                if (row.isNew) {
                  _this12.total += 1;
                }
                row.isNew = false;
                row.isEdit = false;
                isExistHc = false;
                (_row$records2 = row.records) === null || _row$records2 === void 0 ? void 0 : _row$records2.forEach(function (record) {
                  // record.weight = record.weight == '' ? 1 : record.weight 
                  record.isEdit = false;
                  if (record.isHc) {
                    isExistHc = true;
                  }
                });
                if (isExistHc && row.hc_status == -1) {
                  row.hc_status = 0;
                } else if (!isExistHc && row.hc_status != -1) {
                  row.hc_status = -1;
                }
                row.domain = domainName;
                _this12.moveFromTmpDomainRecord(row.domain);
              }
              _this12.isDisabledSaveBtn = false;
              _this12.fullscreenLoading = false;
              _this12.isAddDomain = false;
            case 32:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getReverseIP: function getReverseIP(domainName) {
      var domain_ip = '';
      if (domainName.endsWith('.in-addr.arpa') || domainName.endsWith('.in-addr.arpa.')) {
        domain_ip = this.chopSuffix(domainName).replaceAll('.in-addr.arpa', '');
        domain_ip = domain_ip.split('.').reverse().join('.');
      } else if (domainName.endsWith('.ip6.arpa') || domainName.endsWith('.ip6.arpa.')) {
        domain_ip = this.chopSuffix(domainName).replaceAll('.ip6.arpa', '');
        var domain_ip_arr = domain_ip.split('.');

        // 32位
        if (domain_ip_arr.length != 32) {
          return '';
        }

        // 每个只能是一个字母或数字
        var everyOnlyOne = domain_ip_arr.every(function (item) {
          return item.length == 1;
        });
        if (!everyOnlyOne) {
          return '';
        }

        // 每4个一组，用 : 隔开
        domain_ip = domain_ip_arr.reverse().join('');
        var new_ip_arr = [];
        var idx = 0;
        while (idx < domain_ip.length) {
          var _end = idx + 4;
          new_ip_arr.push(domain_ip.slice(idx, _end));
          idx = _end;
        }
        domain_ip = new_ip_arr.join(':');
      }
      return domain_ip;
    },
    getRecorderType: function getRecorderType(isPrimaryDomain, record) {
      var recorderType = [{
        label: this.$t('region.recordtype-annotation-a'),
        value: 'A'
      }, {
        label: this.$t('region.recordtype-annotation-aaaa'),
        value: 'AAAA'
      }, {
        label: this.$t('region.recordtype-annotation-cname'),
        value: 'CNAME'
      }, {
        label: this.$t('region.recordtype-annotation-mx'),
        value: 'MX'
      }, {
        label: this.$t('region.recordtype-annotation-txt'),
        value: 'TXT'
      }, {
        label: this.$t('region.recordtype-annotation-ns'),
        value: 'NS'
      }, {
        label: this.$t('region.recordtype-annotation-srv'),
        value: 'SRV'
      }, {
        label: this.$t('region.recordtype-annotation-caa'),
        value: 'CAA'
      }, {
        label: this.$t('region.recordtype-annotation-spf'),
        value: 'SPF'
      }, {
        label: this.$t('region.recordtype-annotation-naptr'),
        value: 'NAPTR'
      }];
      if (record.name != 'default') {
        recorderType = [{
          label: this.$t('region.recordtype-annotation-a'),
          value: 'A'
        }, {
          label: this.$t('region.recordtype-annotation-aaaa'),
          value: 'AAAA'
        }, {
          label: this.$t('region.recordtype-annotation-cname'),
          value: 'CNAME'
        }];
      } else if (isPrimaryDomain) {
        recorderType = [{
          label: this.$t('region.recordtype-annotation-a'),
          value: 'A'
        }, {
          label: this.$t('region.recordtype-annotation-aaaa'),
          value: 'AAAA'
        }, {
          label: this.$t('region.recordtype-annotation-mx'),
          value: 'MX'
        }, {
          label: this.$t('region.recordtype-annotation-txt'),
          value: 'TXT'
        }, {
          label: this.$t('region.recordtype-annotation-srv'),
          value: 'SRV'
        }, {
          label: this.$t('region.recordtype-annotation-caa'),
          value: 'CAA'
        }, {
          label: this.$t('region.recordtype-annotation-spf'),
          value: 'SPF'
        }, {
          label: this.$t('region.recordtype-annotation-naptr'),
          value: 'NAPTR'
        }];
      } else if (this.isPtrZone) {
        recorderType = [{
          label: this.$t('region.recordtype-annotation-ptr'),
          value: 'PTR'
        }, {
          label: this.$t('region.recordtype-annotation-ns'),
          value: 'NS'
        }];
      }
      return recorderType;
    },
    setOrderBy: function setOrderBy(orderBy) {
      var _this13 = this;
      this.orderBy = orderBy;
      this.orderType ^= 1;
      this.domainRecords.forEach(function (row) {
        row.records.sort(compare(orderBy, _this13.orderType));
      });
    },
    getOrderClass: function getOrderClass(orderBy) {
      if (this.orderBy != orderBy) {
        return '';
      }
      return this.orderType == 0 ? 'descending' : 'ascending';
    },
    handleSizeChangeWrap: function handleSizeChangeWrap(val) {
      this.pageSize = val;
      this.getDomainRecords();
    },
    handleCurrentChangeWrap: function handleCurrentChangeWrap(val) {
      this.page = val;
      this.getDomainRecords();
    },
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      if (this.searchInfo.extend == "") {
        this.searchInfo.extend = null;
      }
      if (this.searchInfo.status == "") {
        this.searchInfo.status = null;
      }
      this.getDomainRecords();
    },
    getDomainRecords: function getDomainRecords() {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this14$qData$zone$, _this14$tableData;
        var dRecords;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this14.getTableData();
            case 2:
              _this14.zoneStatus = ((_this14$qData$zone$ = _this14.qData.zone[0]) === null || _this14$qData$zone$ === void 0 ? void 0 : _this14$qData$zone$.status) || 0;
              dRecords = viewMapToDomainRegion(_this14.qData['record'], _this14.qZone);
              _this14.domainRecords = [];
              (_this14$tableData = _this14.tableData) === null || _this14$tableData === void 0 ? void 0 : _this14$tableData.forEach(function (obj) {
                var newDomainInfo = deepCopy(obj);
                if (dRecords.has(newDomainInfo.domain)) {
                  _this14.$set(newDomainInfo, 'records', dRecords.get(newDomainInfo.domain));
                }
                _this14.$set(newDomainInfo, 'checked', false);
                _this14.$set(newDomainInfo, 'isPrimaryDomain', newDomainInfo.domain == _this14.zoneFqName);
                _this14.domainRecords.push(newDomainInfo);
              });
              _this14.searchFilters = _objectSpread({}, _this14.searchInfo);
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    }
  },
  mounted: function mounted() {
    var _this15 = this;
    this.$bus.on("scrollOffset", this.stickyOffset);
    this.$bus.on("collapse", function (item) {
      _this15.isCollapse = item;
    });
    // window.onbeforeunload = function (e) {
    //     e = e || window.event;
    //     // 兼容IE8和Firefox 4之前的版本
    //     if (e) {
    //         e.returnValue = '关闭提示';
    //     }
    //     // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
    //     return '关闭提示';
    // }
  },
  // beforeRouteLeave (to, from, next) {
  //   // 导航离开该组件的对应路由时调用
  //   // 可以访问组件实例 `this`
  //   // 该导航可以通过 next(false) 来取消。
  //   const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
  //   if (answer) {
  //       next()
  //   } else {
  //   // 不支持传递回调(因为this实例已经创建可以获取到，所以没必要)
  //       next(false)
  //   }
  // },
  created: function created() {
    var _this16 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _this16.pageSize = 5;
            _this16.searchInfo = _this16.qSearchInfo;
            _this16.$set(_this16.searchInfo, 'viewMode', 1);

            // 获取模板
            Promise.all([store.dispatch('viewinfo/getTplMap'), store.dispatch('viewinfo/getRecordLines', _this16.qZone)]).then(function () {
              _this16.viewOptions = getAllView(_this16.qZone);
              _this16.hcTplMap = getTplMap();
              _this16.getDomainRecords();
            }).catch(function (error) {
              console.log(error);
            });
          case 4:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }))();
  },
  destroyed: function destroyed() {
    // this.$bus.off('collapse')
    this.$bus.off('scrollOffset');
  }
};